'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var key = '__multireducerKey';

exports.default = key;


//////////////////
// WEBPACK FOOTER
// ./~/multireducer/lib/key.js
// module id = 1132
// module chunks = 1 2 3